import React,{Component} from 'react';

import { Alert,Button,ButtonGroup} from 'react-bootstrap';

class PoistonVarmistus extends Component {
  constructor(props){
    super(props);
    this.state = {naytaPoistonVarmistus:this.props.naytaPoistonVarmistus};
    this.hyvaksyPoisto = this.hyvaksyPoisto.bind(this);
    this.peruutaPoisto = this.peruutaPoisto.bind(this);
  }
  componentWillReceiveProps(){


    this.forceUpdate();
  }
  peruutaPoisto(){


    this.props.handlePeruutaPoisto();
  }
  hyvaksyPoisto(){
      this.props.handlePoisto();
  }
  render() {
      if(this.props.naytaPoistonVarmistus){
    return (

      <div className="removeConfirmation alert alert-warning">
        <span className="pull-left">Haluatko varmasti poistaa valitun?</span>
        <div class="btn-group pull-right" role="group">
        <button onClick={this.hyvaksyPoisto} className="danger">Poista</button>
        <button onClick={this.peruutaPoisto} className="btn-primary">Peruuta</button>
        </div>
      </div>


        )
      }else{
        return "";
      }
  }
}

export default PoistonVarmistus;
